export default __webpack_public_path__ + "static/media/percent.d682728d.svg";